import { schemaToCoarse } from '@features/flows/utils/types';
import { synthesizeSchemaFromTypeExpr } from '@features/flows/lib/autocast/schema-utils';

export type PinSpecLike =
  | {
      id?: string;
      type?: string;
      typeExpr?: unknown;
    }
  | undefined;

/**
 * Returns a coarse type token derived from a pin's `type` or `typeExpr`.
 * Falls back to undefined when no coarse type can be determined.
 */
export function deriveCoarseTypeFromPin(pin: PinSpecLike): string | undefined {
  if (!pin) return undefined;

  const coarseFromType = typeof pin.type === 'string' ? pin.type.trim() : '';
  if (coarseFromType) {
    return coarseFromType;
  }

  const hasTypeExprProp = Object.prototype.hasOwnProperty.call(pin, 'typeExpr');
  const typeExpr = (pin as { typeExpr?: unknown }).typeExpr;
  if (hasTypeExprProp && typeExpr != null) {
    try {
      const schema = synthesizeSchemaFromTypeExpr(typeExpr);
      const coarse = schemaToCoarse(schema);
      // If synthesis can't determine a coarse token, don't force "any" here;
      // let callers coalesce with other sources (persisted, runtime, etc.).
      return coarse ?? undefined;
    } catch {
      return undefined;
    }
  }

  return undefined;
}
